import { SITE_NAME, SITE_ORIGIN } from 'constants';
import { dataFaq } from 'pages/Home/Sections/Faq/dataFaq';
import { dataInfoFaqs } from 'pages/Home/Sections/InfoFaqs/data-InfoFaqs';

export const HOME_TITLE =
  'FOXI – KI-Software für Zahnarzt-Abrechnung & Dokumentation';

export const HOME_DESCRIPTION =
  'FOXI erstellt Abrechnung und Dokumentation in Deiner Zahnarztpraxis automatisch per KI – inkl. Sprachassistent und Übertragung in jedes PVS. Jetzt kostenlos testen.';

export const HOME_URL = `${SITE_ORIGIN}/`;
export const LOGO_URL = `${SITE_ORIGIN}/android-chrome-512x512.png`;

const ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;
const SOFTWARE_ID = `${SITE_ORIGIN}/#software`;

/**
 * Structured data for the start page (schema.org JSON-LD). Crawlers and
 * LLM-based search read this even though the visible FAQ answers are only in
 * the DOM while expanded.
 */
export const homeStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': ORGANIZATION_ID,
      name: 'Hopf & Hopf GmbH',
      alternateName: 'FOXI',
      url: HOME_URL,
      logo: LOGO_URL,
      email: 'info@foxi-abrechnung.de',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Glockenstraße 35',
        postalCode: '40476',
        addressLocality: 'Düsseldorf',
        addressCountry: 'DE',
      },
      founder: [
        { '@type': 'Person', name: 'Dr. Felix Hopf', jobTitle: 'Zahnarzt' },
        {
          '@type': 'Person',
          name: 'Dr. Michael Hopf',
          jobTitle: 'Mathematiker',
        },
      ],
      areaServed: 'DE',
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_ORIGIN}/#website`,
      url: HOME_URL,
      name: SITE_NAME,
      inLanguage: 'de-DE',
      publisher: { '@id': ORGANIZATION_ID },
    },
    {
      '@type': 'SoftwareApplication',
      '@id': SOFTWARE_ID,
      name: 'FOXI',
      url: HOME_URL,
      image: LOGO_URL,
      applicationCategory: 'BusinessApplication',
      applicationSubCategory: 'Abrechnungssoftware für Zahnarztpraxen',
      operatingSystem: 'Web, Android, iOS',
      inLanguage: 'de',
      description:
        'FOXI ist eine KI-Software für Zahnarztpraxen, die Abrechnung und Dokumentation automatisch erstellt. Das Praxisteam gibt nur die Behandlung ein oder nutzt den Sprachassistenten; FOXI berechnet alle Abrechnungspositionen, schreibt die Dokumentation und überträgt beides in das bestehende Praxisverwaltungssystem (PVS).',
      featureList: [
        ...dataInfoFaqs.info.map((item) => item.title),
        'Erstellung von KVs, MKVs und HKPs',
        'DSGVO-konforme Speicherung auf Servern in Deutschland',
      ],
      audience: {
        '@type': 'BusinessAudience',
        audienceType: 'Zahnarztpraxen in Deutschland',
      },
      offers: {
        '@type': 'Offer',
        price: '249',
        priceCurrency: 'EUR',
        description:
          'Ab 249 € zzgl. USt. pro Monat für 1-Behandler-Praxen; ab zwei Behandlern 149 € zzgl. USt. pro Monat und Behandler. Kostenloser Test möglich.',
        url: HOME_URL,
        availability: 'https://schema.org/InStock',
      },
      provider: { '@id': ORGANIZATION_ID },
    },
    {
      '@type': 'FAQPage',
      '@id': `${SITE_ORIGIN}/#faq`,
      mainEntity: dataFaq.map((faq) => ({
        '@type': 'Question',
        name: faq.title,
        acceptedAnswer: { '@type': 'Answer', text: faq.description },
      })),
    },
  ],
};
